/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ArchiveActionType {
    NoActionRequired = 0,
    ClearExisting = 1,
    ReassignToExisting = 2,
    CreateNew = 3,
}
